export default "__VITE_ASSET__Dyamkwfg__"